import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

// third party modules
import { AngularFireDatabaseModule } from "angularfire2/database";

// services
import { SpellsService } from "./services/spells/spells.service";

// pipes
import { PrintAllPipe } from "./pipes/printAll.pipe";

@NgModule({
    declarations: [
        PrintAllPipe
    ],
    imports: [
        CommonModule,
        RouterModule,
        AngularFireDatabaseModule
     ],
    exports: [
        PrintAllPipe
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                SpellsService
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/shared/shared.module.ts